export const LOCATION_FETCH_REQUESTED = 'LOCATION_FETCH_REQUESTED';
export const LOCATION_FETCH_SUCCEEDED = 'LOCATION_FETCH_SUCCEEDED';
export const LOCATION_FETCH_FAILED = 'LOCATION_FETCH_FAILED';

export const LOCATION_SAVE_REQUESTED = 'LOCATION_SAVE_REQUESTED';
export const LOCATION_SAVE_SUCCEEDED = 'LOCATION_SAVE_SUCCEEDED';
export const LOCATION_SAVE_FAILED = 'LOCATION_SAVE_FAILED';

export const LOCATION_DELETE_REQUESTED = 'LOCATION_DELETE_REQUESTED';
export const LOCATION_DELETE_SUCCEEDED = 'LOCATION_DELETE_SUCCEEDED';
export const LOCATION_DELETE_FAILED = 'LOCATION_DELETE_FAILED';
